"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.listAnalysisResultsOutputDtoSchema = exports.listAnalysisResultsInputDtoSchema = void 0;
const z = __importStar(require("zod"));
const cadstrom_shared_1 = require("@cadstrom/cadstrom-shared");
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const zod_preprocessors_js_1 = require("../utils/zod-preprocessors.js");
const sortFieldSchema = z.enum([
    'requirementId',
    'expected',
    'actual',
    'status',
    'computedStatus',
    'createdAt',
    'updatedAt',
    'isReviewed',
]);
const sortOptionsSchema = z.object({
    field: sortFieldSchema,
    direction: z.enum(['asc', 'desc']),
});
const listAnalysisResultsInput = {
    limit: z.number().optional(),
    cursor: z.string().optional(),
    projectId: z.string(),
    buildId: z.string().optional(),
    resultTypes: z.array(z.string()).optional(),
    status: sigma_engine_shared_1.RequirementInstanceResultStatusSchema.optional(),
    sort: z.array(sortOptionsSchema).optional(),
    columnFilters: cadstrom_shared_1.QueryBuilder.createColumnFilterZodSchema(cadstrom_shared_1.AnalysisResult.analysisResultFilterSchema).optional(),
    columnFilterLogicOperator: cadstrom_shared_1.QueryBuilder.logicOperatorSchema.optional(),
    searchQuery: z.string().optional(),
};
exports.listAnalysisResultsInputDtoSchema = z.object(listAnalysisResultsInput);
const listAnalysisResultsOutput = {
    results: z.array(z.preprocess(zod_preprocessors_js_1.preprocessResult, sigma_engine_shared_1.RequirementInstanceResultSchema)),
    hasNextPage: z.boolean(),
    nextCursor: z.string().nullable(),
    totalCount: z.number().optional(),
};
exports.listAnalysisResultsOutputDtoSchema = z.object(listAnalysisResultsOutput);
//# sourceMappingURL=list-analysis-results.dto.js.map